export const PHONE_MASK_MAX_DIGITS = 9;

export const formatPhoneMask = (digits: string) => {
  const out = '+380 (' + digits.slice(0, 2).padEnd(2, '_') + ') ';
  return out
    + digits.slice(2, 5).padEnd(3, '_') + '-'
    + digits.slice(5, 7).padEnd(2, '_') + '-'
    + digits.slice(7, 9).padEnd(2, '_');
};

export const toRawPhoneDigits = (formattedPhone: string) => formattedPhone.replace(/\D/g, '');

export const stripPhoneCountryCode = (digits: string) => digits.startsWith('380') ? digits.slice(3) : digits;

export const DATE_MASK_MAX_DIGITS = 8;

export const formatDateOfBirthMask = (digits: string) => {
  return digits.slice(0, 2).padEnd(2, '_') + '.'
    + digits.slice(2, 4).padEnd(2, '_') + '.'
    + digits.slice(4, 8).padEnd(4, '_');
};
